import { useId } from 'react'
import { AlertCircle } from 'lucide-react'
import { cn } from '../lib/cn.js'
import { Icone } from './Icone.js'

/**
 * Envelope de rótulo, dica e erro — compartilhado por todos os campos.
 *
 * O erro é ligado ao controle por aria-describedby e marcado com role="alert":
 * no checkout, quem usa leitor de tela precisa ouvir "telefone inválido" sem
 * ter de sair caçando a mensagem.
 */
export type CampoProps = {
  rotulo: string
  // "| undefined" explícito: com exactOptionalPropertyTypes ligado, "dica?: string"
  // recusa undefined passado de propósito, que é o caso natural aqui.
  dica?: string | undefined
  erro?: string | undefined
  obrigatorio?: boolean | undefined
  children: (props: {
    id: string
    descritoPor?: string | undefined
    invalido: boolean
  }) => React.ReactNode
  className?: string | undefined
}

export function Campo({ rotulo, dica, erro, obrigatorio, children, className }: CampoProps) {
  const id = useId()
  const idDica = `${id}-dica`
  const idErro = `${id}-erro`
  const descritoPor = [dica ? idDica : null, erro ? idErro : null].filter(Boolean).join(' ') || undefined

  return (
    <div className={cn('du-campo', erro && 'du-campo--erro', className)}>
      <label className="du-campo__rotulo" htmlFor={id}>
        {rotulo}
        {obrigatorio ? <span aria-hidden className="du-campo__obrigatorio">*</span> : null}
      </label>
      {children({ id, descritoPor, invalido: Boolean(erro) })}
      {dica && !erro ? (
        <span className="du-campo__dica" id={idDica}>
          {dica}
        </span>
      ) : null}
      {erro ? (
        <span className="du-campo__erro" id={idErro} role="alert">
          <Icone de={AlertCircle} tamanho={16} />
          {erro}
        </span>
      ) : null}
    </div>
  )
}
